import { TranslocoHttpLoader } from './translation-loader';
import { isDevMode } from '@angular/core';
import { TranslocoOptions } from '@jsverse/transloco';

export const provideTranslocoConfig: TranslocoOptions = {
  config: {
    availableLangs: ['nl'],
    defaultLang: 'nl',
    fallbackLang: 'nl',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    missingHandler: { allowEmpty: true, useFallbackTranslation: true },
  },
  loader: TranslocoHttpLoader,
};
